import PropTypes from "prop-types"
import parse from "html-react-parser"
import classnames from "classnames"
import queryIcon from "images/icons/icon-new-connection-query.svg?raw"

import styles from "./learn_more_button.module.scss"

const LearnMoreButton = ({ darkHeader, title, url }) => {
  return (
    <a
      className={classnames("learn-more-icon", styles["learn-more"], { [styles["dark-header"]] : darkHeader })}
      title={title}
      // eslint-disable-next-line react/jsx-no-target-blank
      target="_blank"
      href={url}
      rel="noreferrer"
    >
      <span>{parse(queryIcon)}</span>
    </a>
  )
}

LearnMoreButton.propTypes = {
  darkHeader: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
}

LearnMoreButton.defaultProps = {
  darkHeader: false,
  title: "Learn more",
}

export default LearnMoreButton
